import { observer } from 'mobx-react-lite'
import { Box, Button } from 'shared/ui'

type IPhoneCheckrDetailsModalActionsProps = {
  onClose: () => void
  onActivate: () => void
}

export const PhoneCheckrDetailsModalActions = observer(
  ({ onClose, onActivate }: IPhoneCheckrDetailsModalActionsProps) => {
    return (
      <Box marginInline={'1px'}>
        <Button
          typeBtn='contained'
          text='Cancel'
          size='medium'
          contained='secondary'
          onClick={onClose}
        />
        <Button typeBtn='contained' text='Activate' size='medium' onClick={onActivate} />
      </Box>
    )
  }
)
